export default __webpack_public_path__ + "static/media/findMyWayCut.e1dac191.gif";